

import Repository from "./Repository";
import _ from "lodash";


const getStudentPath = (path)=>{
    return `student/${path}`;
}
//API CALL for Admin Dashboard flow
class QuizRepository extends Repository {
    stdgetQuizlist = async (params) => {
       if(!params){
        params=''
       }
        try {
            const data = await this.getData(getStudentPath(`quiz/list/`+params));
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    stdstartQuiz = async (params) => {
        try {
            const data = await this.postData(getStudentPath('quiz/start'), params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    stdgetQuestion = async (params) => {
        try {
            const data = await this.getData(getStudentPath('quiz/listWithQuestions/'+params));
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    stdgetquizAttempts = async (params) => {
        try {
            const data = await this.getData(getStudentPath('quiz/viewMarks/'+params));
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    stdAssessmentQuestionNReason = async (params) => {
        try {
            const data = await this.postData(getStudentPath('quiz/questionWiseAssessment'), params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };
        
    setStudentAnswer = async (params) =>{
        try {
            const data = await this.postData(getStudentPath('quiz/answer'), params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    }

    stdquizComplted = async (params) =>{
        try {
            const data = await this.postData(getStudentPath('quiz/complete'), params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    }

    stdgetAQuizQuestion = async ({quizId,qId, time_spent }) => {
        try {
            const data = await this.postData(
                getStudentPath(`quiz/fetchQuizQuestion/${quizId}/${qId}`),
                {
                    time_spent: Math.max(0, Math.floor(Number(time_spent) || 0)),
                }
            );
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    getStudentQuizState = async (quizId) => {
        try {
            const data = await this.getData(getStudentPath(`quiz/checkQuizStartOrFetch/${quizId}`));
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    getGraphData = async (quizId) => {
        try {
            const data = await this.getData(getStudentPath(`quiz/resultsGraph/${quizId}`));
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    getQuizRankData = async (quizId) => {
        try {
            const data = await this.getData(getStudentPath(`quiz/rank/${quizId}`));
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    saveMistakeLog = async (params) => {
        try {
            const response = await this.postData(getStudentPath('quiz/mistake-log/create'), params);
            return _.get(response, 'data');
        } catch (error) {
            return { error };
        }
    }

    updateMistakeLog = async ({ quizMistakeLogId, title }) => {
        try {
            const response = await this.putData(
                getStudentPath(`quiz/mistake-log/update/${quizMistakeLogId}`),
                { title }
            );
            return _.get(response, 'data');
        } catch (error) {
            return { error };
        }
    }

    getMistakeLog = async (quizAttemptId) => {
        try {
            const response = await this.getData(getStudentPath(`quiz/mistake-log/list/${quizAttemptId}`));
            return _.get(response, 'data');
        } catch (error) {
            return { error };
        }
    }
}

export default new QuizRepository("quiz");
